import { Fragment, useEffect, useState } from "react";
import { useCart, useUser } from "hooks";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { logout } from "store/auth/actions";
import { destroy } from "store/shop/actions";
import { API_ENDPOINTS } from "utilities";
import CategoryQuery from "./products/CategoryQuery";
import cart from "assets/pictures/cart.svg";
import logo from "assets/pictures/header-logo.png";
import searchIcon from "assets/pictures/search.svg";
import whishlist from "assets/pictures/whishlist.svg";
import { useShop } from "hooks";
import { Modal, Button } from "react-bootstrap"; // Import react-bootstrap components


function Header() {
  const dispatch = useDispatch();
  const { isLoggedIn, info } = useShop();
  const { user } = useUser();
  const { totalQuantity } = useCart();
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All Categories");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // For mobile click toggle
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const shop_id = info?.id || 0;
  const shop_about = info?.about_us || "Coming Soon!!"
  const { categories, loading, error } = CategoryQuery(shop_id);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  // Function to handle search navigation
  const onSubmit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();

    if (search) params.set("search", search);
    if (category !== "All Categories") params.set("category", category);

    navigate(`/products?${params.toString()}`);
  };

  // Shop logout
  const removeShop = () => {
    dispatch(destroy(API_ENDPOINTS.LOGOUT)).then((response) => {
      if (response) {
        window.location.href = "/";
      }
    });
  };

  // User logout
  const logoutUser = () => {
    dispatch(logout(API_ENDPOINTS.AUTH.LOGOUT)).then((response) => {
      if (response?.success) {
        window.location.href = "/products";
      }
    });
  };

  // Toggle dropdown on click (for mobile)
  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const profile = () => {
    window.location.href = "/profile";
  };

  return (
    <Fragment>
      <div className="navhead">
        <div className="logoo">
          <Link to="/products">
            <img src={logo} style={{ height: "3rem" }} alt="Logo" />
          </Link>
        </div>

        <ul className="navhead-links" id="myDIV">
          <li className="">
            <button
              onClick={openModal}
              className="about-store-btn"
              aria-label="Open about the store modal"
            >
              About The Store
            </button>
          </li>
          {/* Bootstrap Modal */}
          <Modal show={isModalOpen} onHide={closeModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>About the Store</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {shop_about}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <li>
            <div className="wrapper">
              <div className="container searchcontainer">
                <div className="search-bar">
                  <form onSubmit={onSubmit} className="search-form">
                    <div className="search-category">
                      <select
                        className="category-dropdown form-select form-filter"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        disabled={loading}
                        aria-label="Select category"
                      >
                        <option value="All Categories">All Categories</option>
                        {loading ? (
                          <option disabled>Loading...</option>
                        ) : error ? (
                          <option disabled>{error}</option>
                        ) : Array.isArray(categories) &&
                          categories.length > 0 ? (
                          categories.map((cat) => (
                            <option key={cat.id} value={cat.id}>
                              {cat.name}
                            </option>
                          ))
                        ) : (
                          <option disabled>No categories available</option>
                        )}
                      </select>
                    </div>
                    <div className="search-input-container">
                      <input
                        type="text"
                        className="search-input"
                        placeholder="Search for items..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <button type="submit" className="search-button">
                        <img
                          src={searchIcon}
                          className="search-icon"
                          alt="Search"
                        />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </li>

          <li className="d-none">
            <Link to="/wishlist">
              <img src={whishlist} className="heart-img" alt="Wishlist" />
            </Link>
          </li>

          <li>
            <Link to="/cart" className="cart-container">
              {totalQuantity > 0 && (
                <span className="cart-badge">{totalQuantity}</span>
              )}
              <img src={cart} className="cart-img" alt="Cart" />
            </Link>
          </li>

          <li className="account-dropdown">
            <div className="account-info" onClick={toggleDropdown}>
              <i
                className="fas fa-user"
                style={{ fontSize: "20px", marginRight: "8px" }}
              ></i>
              <span className="welcome-text">
                Welcome, {user?.name || "Guest"}
              </span>
            </div>
            <ul className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
              {user && (
                <>
                  <li>
                    <button className="dropdown-item" onClick={logoutUser}>
                      Logout User
                    </button>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>

                  <li>
                    <button
                      to="/profile"
                      onClick={profile}
                      className="dropdown-item"
                    >
                      Profile
                    </button>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                </>
              )}
              <li>
                <button className="dropdown-item" onClick={removeShop}>
                  Logout Shop
                </button>
              </li>
            </ul>
          </li>
        </ul>

        <div className="hamburger">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </Fragment>
  );
}

export default Header;